import { selectClassificationLoading, selectCommunityResultHistory } from '@classification-testing/state/selectors';
import { Illustration, IllustrationType, IllustrationLayout, SectionHeader } from '@core/components';
import { Shimmer, Card } from '@soteria/design-system-ve';
import { ClassificationResultItem } from '@soteria-ui/src/classification-testing/components';
import { useAppSelector } from '@store';

import * as styles from './ClassificationResultsSection.css';

interface ClassificationResultsSectionProps {
  communityId?: string;
  communityName: string;
}

/**
 * Result History Section component
 */
export function ClassificationResultsSection({ communityId, communityName }: ClassificationResultsSectionProps) {
  // Get loading state and results from Redux
  const isLoading = useAppSelector(selectClassificationLoading);
  const results = useAppSelector(selectCommunityResultHistory(communityId || ''));

  return (
    <div>
      <SectionHeader description="View result history" title="Classification Results" />
      <div className={styles.container}>
        <Card>
          {isLoading && <Shimmer className={styles.shimmerLoader} />}
          {/* Display all results */}
          {results.map(result => (
            <ClassificationResultItem key={result.id} _classifiedText={result.text || ''} _promptVersion="default" result={result} />
          ))}
          {results.length === 0 && !isLoading && (
            <div className={styles.emptyStateContainer}>
              <Illustration
                description={`Enter content and click "Classify" to begin testing for ${communityName}.`}
                layout={IllustrationLayout.HORIZONTAL}
                title="No classification results yet"
                type={IllustrationType.EMPTY}
              />
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
